<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>账号认证</span>
    </div>
    <div class="cont">
        <div class="title">账号认证</div>
    </div>
    <div class="auth_box">
        <div class="top">
            <div class="type">
                <p>个人认证</p>
                <p class="tips">完成账号认证，就可以发布众筹啦</p>
            </div>
            <el-button type="primary" @click="goAuth">立即认证</el-button>
        </div>
        <div class="explain">
            <p>认证资料准备：</p>
            <p>本人手持身份证的半身照，需包含身份证正反面。</p>
            <p>*身份证人像面、国徽面信息均可清晰识别；</p>
        </div>
    </div>
    <div class="auth_box">
        <div class="top">
            <div class="type">
                <p>企业认证</p>
                <p class="tips">完成账号认证，就可以发布众筹啦</p>
            </div>
            <el-button type="primary" @click="goAuth">立即认证</el-button>
        </div>
        <div class="explain">
            <p>认证资料准备：</p>
            <ul>
                <li>营业执照原件扫描件或加盖公司鲜章的复印件</li>
                <li>企业法人身份证照片</li>
            </ul>
            <p>*资料图片需清晰完整，且在有效期内</p>
        </div>
    </div>
    <div class="auth_box">
        <div class="top">
            <div class="type">
                <p>注意事项</p>
            </div>
        </div>
        <ul>
            <li>申请创意和众筹项目前，需先完成账号认证。</li>
            <li>项目结算款项仅限提现至开户名称与认证主体名称一致的银行账户。</li>
            <li>账号认证审核通过后，不支持修改；每6个月进行一次账号审核</li>
        </ul>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import domain from '@/service/domain'
const domain_www = domain.www;
const router = useRouter()
const goAuth = () => {
    location.href = domain_www+'/identity/type';
}
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}
</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    padding: 0 0 40px 0;
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.cont{
    color: #1A1A1A;
    .title{
        font-size: 24px;
        font-weight: 600;
    }
}
.auth_box{
    margin: 20px 0 0 0;
    padding: 30px;
    background: #F7F7F7;
    border-radius: 8px;
    color: #1A1A1A;
    ul{
        padding: 0 0 0 20px;
        li{
            list-style: disc;
        }
        // li::marker{
        //     color: #00C4A1;
        // }
    }
    .top{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .el-button{
            width: 106px;
            height: 36px;
        }
        .type{
            p{
                font-size: 18px;
                line-height: 1;
                font-weight: 600;
                margin: 0 0 10px 0;
                &.tips{
                    font-weight: 400;
                    font-size: 14px;
                }
            }
        }
    }
    .explain{
        background: #FFF;
        margin: 23px 0 0 0;
        width: 100%;
        border-radius: 8px;
        padding: 20px;
        font-size: 14px;
        line-height: 21px;
    }
}
</style>